import { Component, OnInit } from '@angular/core';
import { TitleService } from 'src/app/_services/title.service';
import { AppState } from 'src/app/state/app.state';
import { LxmAppModule, UserAction } from 'src/app/enum';

@Component({
  selector: 'reports-layout',
  templateUrl: './reports.layout.html',
  host: { 'class': 'content' },
  styleUrls: ['./reports.layout.scss']
})
export class ReportsLayout implements OnInit {
  public LxmAppModule = LxmAppModule;
  public UserAction = UserAction;

  private title = 'navigator.links.reports';

  constructor(
    public appState: AppState,
    private _titleService: TitleService
  ) {}

  public ngOnInit() {
    this._titleService.setTitle(this.title);
  }
}
